'use client';
import React, { useState } from 'react';

import styles from './index.module.scss';

export default function Breadcrumb({ navList = [] }: any) {
    return (
        <nav className={`${styles.breadcrumb}`}>
            <ol>
                {navList?.map((item: any, index: number) => {
                    return (
                        <React.Fragment key={index}>
                            <li key={index} className={`breadcrumb-item ${index === navList.length - 1 ? 'breadcrumb-page-name' : ''}`}>
                                {item?.link ? <a href={item?.link}>{item.title}</a> : item.title}
                            </li>
                            {index !== navList.length - 1 && <li className="breadcrumb-item-separator">/</li>}
                        </React.Fragment>
                    );
                })}
            </ol>
        </nav>
    );
}
